import cx from 'classnames';
import type { FC, ReactNode } from 'react';

import { Icon } from '@zen/DesignSystem';
import type { IconName } from '@zen/Styleguide';

interface Props {
  children: ReactNode;
  icon?: IconName;
  isActive: boolean;
  isHighlighted?: boolean;
  label: string;
}

const NavItem: FC<Props> = (props) => {
  const { children, icon, isActive, label } = props;

  const classNames: string = cx(
    {
      'text-azure-base': isActive,
      'text-navy-base hover:text-azure-base': !isActive
    },
    'text-base xl:text-sm transition-all duration-200 ease-linear leading-normal',
    'flex items-center py-1.5 pl-6 cursor-pointer'
  );

  const activeIndicatorClassNames: string = cx(
    { 'bg-azure-base': isActive, 'bg-transparent': !isActive },
    'w-1 h-6 rounded-l transition-all duration-200 ease-linear'
  );

  return (
    <div className={classNames} data-component="nav-item" data-testid="nav-item">
      {icon && <Icon className="mr-2 text-sm xl:text-base" icon={icon} />}
      <span>{label}</span>
      <span className="flex ml-auto">{children}</span>
      <div className={activeIndicatorClassNames} />
    </div>
  );
};

export default NavItem;
